import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('SellersFilter', SellersFilterData);

    SellersFilterData.$inject = ['KISS_SELLER'];

    /* @ngInject */
    function SellersFilterData(KISS_SELLER) {
        Seller.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            preparBeforeSearch: preparBeforeSearch,
            setPage: setPage,
            setPageSize: setPageSize,
            setSort: setSort,
            resetSort: resetSort,
        };

        function Seller(sellersFilterData) {
            if (!sellersFilterData) {
                this.buildEmpty();
            } else {
                this.build(sellersFilterData);
            }
        }

        return Seller;

        /////////////////////

        function buildEmpty() {
            this.sellerId = null;
            this.legalEntityId = null;
            this.councountryCodetry = null;
            this.statuses = _.reject(KISS_SELLER.seller.status, s => s.value === 'DUPLICATE');
            this.email = null;
            this.lang = null;
            this.pageCriteria = {
                pageSize: KISS_SELLER.seller.pagination.defaultPageSize,
                page: KISS_SELLER.seller.pagination.defaultPage,
                sorts: KISS_SELLER.seller.pagination.defaultSort,
            };
        }

        function build(sellersFilterData) {
            this.sellerId = sellersFilterData.sellerId || null;
            this.legalEntityId = sellersFilterData.legalEntityId || null;
            this.countryCode = sellersFilterData.countryCode || null;
            this.statuses = sellersFilterData.statuses || [];
            this.email = sellersFilterData.email || null;
            this.lang = sellersFilterData.lang || null;
            this.pageCriteria = {
                pageSize: sellersFilterData.pageSize || KISS_SELLER.seller.pagination.defaultPageSize,
                page: sellersFilterData.page || KISS_SELLER.seller.pagination.defaultPage,
                sorts: _setSort(sellersFilterData.sorts),
            };
        }

        function _setSort(sorts) {
            if (!sorts || sorts.length === 0) {
                return KISS_SELLER.seller.pagination.defaultSort;
            }
            return sorts;
        }

        /**
         *
         */
        function preparBeforeSearch() {
            var clone = new Seller(this);
            clone.pageCriteria = this.pageCriteria;
            if (this.seller) {
                if (this.seller.legalEntityId) {
                    clone.legalEntityId = this.seller.legalEntityId;
                } else {
                    clone.sellerId = this.sellerId;
                }
            }
            clone.countryCode = this.country ? this.country.code : null;
            clone.statuses = this.statuses ? _.map(this.statuses, 'value') : null;
            return clone;
        }

        /**
         * Indiquer la page
         */
        function setPage(page) {
            this.pageCriteria.page = page;
        }

        /**
         * Changement de pagination
         */
        function setPageSize(pageSize) {
            this.pageCriteria.pageSize = pageSize;
        }

        /**
         * Mise à jour du tri (tri sur une seule colonne)
         */
        function setSort(sorts) {
            this.pageCriteria.sorts = sorts;
        }

        /**
         * Lorsqu'on ne souhaite aucun tri
         */
        function resetSort() {
            this.pageCriteria.sorts = [];
        }
    }
})();
